import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { SiteId } from "@medoma/models/sites";

type IChatInfoMessages = {
  primary: string | MessageDescriptor;
  secondary: string | MessageDescriptor;
};

// We don't translate user-provided texts for single-language organizations/sites.
/* oxlint-disable lingui/no-unlocalized-strings */
const capioAhc = {
  stGoran: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  norrtalje: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  taby: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  vasterort: {
    primary:
      "Chatten är för frågor och ärenden som inte är akuta. Vi svarar så snart vi kan.",
    secondary:
      "Vid akuta eller brådskande besvär, ring ASIH. Vid livshotande tillstånd, ring 112.",
  },
  sollentuna: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  dalen: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  handen: {
    primary: "Vi svarar alla dagar mellan 08.00 och 15.00.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  nacka: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  sodertalje: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  haga: {
    primary: "Vi svarar vardagar 08.00-15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
};

const hahag = {
  hhagZollikon: {
    primary: "Bei akuten Problemen, rufen Sie 044 455 33 03 an.",
    secondary: "Wir antworten zu Bürozeiten innerhalb von 2 Stunden.",
  },
};

const slso = {
  solnastrand: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  danderyd: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  jarfalla: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  nacka: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  handen: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  huddinge: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  ost: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  vast: {
    primary: "Vi svarar vardagar mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
};

const ssh = {
  bromma: {
    primary: "Vi svarar vardagar mellan 07.30 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  innerstaden: {
    primary: "Vi svarar vardagar mellan 07.30 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
};

const sus = {
  lund: {
    primary: "Vi svarar alla dagar i chatten mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
  malmo: {
    primary: "Vi svarar alla dagar i chatten mellan 08.00 och 15.30.",
    secondary: "Ring alltid vid akuta besvär.",
  },
};
/* oxlint-enable lingui/no-unlocalized-strings */

const medoma = {
  vasastan: {
    primary: msg`Vi svarar inom 24 timmar.`,
    secondary: msg`Ring alltid vid akuta besvär.`,
  },
  kungsholmen: {
    primary: msg`Vi svarar inom 24 timmar.`,
    secondary: msg`Ring alltid vid akuta besvär.`,
  },
};

const ksgr = {
  chur: {
    primary: msg`Bei akuten Problemen rufen Sie 081 255 26 26 (08:00 - 17:30h) und ausserhalb dieser Zeiten 081 256 75 00 an.`,
    secondary: msg`Wir antworten zu Bürozeiten innerhalb von 2 Stunden.`,
  },
};

const rakus = {
  rakus: {
    primary: msg`Mēs atbildēsim 15 munūšu laikā.`,
    secondary: msg`Akūtas situācijas gadījumā vienmēr zvaniet.`,
  },
};

const qa = {
  norra: {
    primary: msg`Vi svarar inom 24 timmar.`,
    secondary: msg`Ring alltid vid akuta besvär.`,
  },
  sodra: {
    primary: msg`Vi svarar inom 24 timmar.`,
    secondary: msg`Ring alltid vid akuta besvär.`,
  },
};

const allMessages: Record<SiteId, IChatInfoMessages> = {
  ...capioAhc,
  ...medoma,
  ...hahag,
  ...ksgr,
  ...rakus,
  ...qa,
  ...slso,
  ...ssh,
  ...sus,
};

export const getChatInfoMessages = (siteId: SiteId): IChatInfoMessages => {
  return allMessages[siteId];
};
